import React from "react";
// import logo from './logo.svg';
import "./App.css";
// import Login from "./Login";
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./Home";

import { PageLayout } from "./PageLayout";

import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
} from "@azure/msal-react";

const theme = createTheme({
    typography: {
        fontFamily: `"XfinityBrownTT-Regular"`,
    },
      components: {
    MuiDialog: {
      defaultProps: {
        onClick: (e) => e.stopPropagation(),
        BackdropProps: {
          sx: {
            pointerEvents: 'none',
          },
        },
      },
    },
  },
});


/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {
    return (
        <div className="App">
            <AuthenticatedTemplate>
                <Home />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <h5 className="card-title" style={{ textAlign: "center" }}>
                    Please sign-in to access Referral Candidates Portal
                </h5>
            </UnauthenticatedTemplate>
        </div>
    );
};

function App() {
    return (
        <ThemeProvider theme={theme}>
            <PageLayout>
                <MainContent />
            </PageLayout>
        </ThemeProvider>
    );
}

export default App;
